class LandingPageNumberedList extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.section = this;
    this.swiperEl = this.section.querySelector(".swiper");
    this.pagination = this.section.querySelector(".swiper-pagination");

    import(flu.chunks.swiper).then((_ref) => {
      let { Swiper, Pagination } = _ref;
      this.slider = new Swiper(this.swiperEl, {
        modules: [Pagination],
        slidesPerView: 1,
        spaceBetween: 4,
        resistance: false,
        loop: true,
        autoHeight: true,
        pagination: {
          el: this.pagination,
          type: "bullets",
          bulletElement: "span",
          bulletClass: "swiper-pagination-bullet",
          clickable: true,
        },
      });
    });
  }
  disconnectedCallback() {}
}
customElements.define(
  "numbered-list-block-media-slider",
  LandingPageNumberedList
);
